import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';

// Import layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Import page components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ExperiencePage from './pages/ExperiencePage';
import ProjectsPage from './pages/ProjectsPage';
import SkillsPage from './pages/SkillsPage';
import ContactPage from './pages/ContactPage';

// Import styles
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/Theme';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <Router>
                <AppContainer>
                    <Header />
                    <Main>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/experience" element={<ExperiencePage />} />
                            <Route path="/projects" element={<ProjectsPage />} />
                            <Route path="/skills" element={<SkillsPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                        </Routes>
                    </Main>
                    <Footer />
                </AppContainer>
            </Router>
        </ThemeProvider>
    );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.main`
  flex: 1;
`;

export default App;
